/**
 * The bug species, by name (TOADO-297).
 *
 * Separate from the sprite image on purpose. `shapes.ts` needs these names to
 * describe a pin, and every consumer of the shape model imports `shapes.ts`;
 * if the names lived beside the base64 sprite, an unbundled consumer would
 * load twenty kilobytes of image to read five strings.
 *
 * The order is the tile order in the sprite, so this list and
 * `scripts/build-bug-sprite.mjs` have to agree. A pin stores the name and
 * never the index, so reordering is safe for stored pins as long as the
 * sprite is regenerated with it. The generator parses this literal declaration
 * and requires its single-quoted values and `] as const` terminator.
 */
export const BUG_VARIANTS = ['ladybird', 'bee', 'dragonfly', 'grasshopper', 'ant'] as const;

export type BugVariant = typeof BUG_VARIANTS[number];
